module.exports = __webpack_public_path__ + "img/emailnotification.1a2bfd51.png";